import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { User } from '../../../@core/data/model/user';
import { UserApiService } from '../../../@core/data/rest/user/user-service';

import {PermissionService } from '../../../@core/data/rest/permission/permissions-service';
import { Permission } from '../../../@core/data/model/permission';
import { AuthService } from '../../../auth/auth.service';
import { plainToClass } from 'class-transformer';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-userform',
  templateUrl: './userform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class UserFormComponent implements OnInit {

  @Input() userEdit: User;

  select: number;

  permissions: Permission[];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
      protected dialogRef: NbDialogRef<UserFormComponent>,
      public userService: UserApiService,
      public sharedMethods: SharedMethods,
      public permissionService: PermissionService,
      public authService: AuthService) {
  }


  ngOnInit(): void {

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });


    if (this.permissionService.permissions === undefined) {

      this.permissionService.getPermissions().then( permissions => {

        // alert(JSON.stringify(clients));
        this.permissions = permissions;

      });

    }else {
      this.permissions = this.permissionService.permissions;
    }

    this.dropdownSettings = {
        singleSelection: false,
        idField: 'value',
        textField: 'designation',
        selectAllText: 'Tout Selectionner',
        unSelectAllText: 'Tout DeSelectionner',
        itemsShowLimit: 5,
        allowSearchFilter: true,
        searchPlaceholderText: 'Rechercher',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
    };

    this.selectedItems = this.userEdit.permissions;

  }

  onItemSelect(item: any) {

    // tslint:disable-next-line:no-console
    /* for ( let i = 0; i < this.partenaireService.getLocalPartner(this.typePartner).length; i++) {
      if (this.partenaireService.getLocalPartner(this.typePartner)[i].id === item.item_id ) {
        this.facture.partenaire = this.partenaireService.getLocalPartner(this.typePartner)[i];
      }
    } */
    // this.partenaireEdit.plan_tarifaire = item;

    this.userEdit.permissions = this.selectedItems ;

  }

  onSelectAll(event) {
    this.userEdit.permissions = this.permissions ;
  }

  onDeSelect(item: any) {
    // this.partenaireEdit.plan_tarifaire = null;
    this.userEdit.permissions = this.selectedItems ;
  }


  cancel() {
    if (this.userService.iSconnecting === false) {
      this.dialogRef.close();
    }
  }

  submit() {
    // alert(JSON.stringify(this.partenaireEdit));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

    let valid: Validator;
    valid = this.sharedMethods.validateUser(this.userEdit, this.userService.users);

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        if (this.userService.iSconnecting === false) {

            // tslint:disable-next-line:no-console
            console.log(this.userEdit);

            this.userService.saveUser(this.userEdit).then( user => {

                // this.userEdit.id = user.id;
                this.dialogRef.close(plainToClass(User, user as object));
                // alert(JSON.stringify(this.fluxstockedit));

            }, (err) => {

                this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
        }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


  }

 toggleDirection(newDirection) {
  // this.directionService.setDirection(newDirection);
  // tslint:disable-next-line:no-console
  // console.log(newDirection);
  this.userEdit.is_active = newDirection;
 }


}
